import useFetch from '../../../hooks/useFetch';
import { ServiceEvents } from '../shared/interfaces';
import { useState } from 'react';
import { EndPoints } from '../EndPoints';
import { BankAccountReason, BankAccountReasonFilters } from '../../models/BankAccountReason';

const useBankAccountReasonService = () => {
    const { doGet, doPost, doPut, doDelete } = useFetch();

    const [fetchingGetBankAccountReasons, setFetchingGetBankAccountReasons] = useState(false);
    const [fetchingStoreBankAccountReason, setFetchingStoreBankAccountReason] = useState(false);
    const [fetchingEditBankAccountReason, setFetchingEditBankAccountReason] = useState(false);
    const [fetchingUpdateBankAccountReason, setFetchingUpdateBankAccountReason] = useState(false);
    const [fetchingDeleteBankAccountReason, setFetchingDeleteBankAccountReason] = useState(false);
    const [fetchingActiveBankAccountReason, setFetchingActiveBankAccountReason] = useState(false);

    const getBankAccountReasons = (filters: BankAccountReasonFilters, events: ServiceEvents = {}) => {
        const queryString = Object.entries(filters)
            .map(([key, value]) => `${key}=${value}`)
            .join('&');
        const url = `${EndPoints.BANK_ACCOUNT_REASONS.GET_BANK_ACCOUNT_REASONS}?${queryString}`;
        doGet({ ...events, url, setFetching: setFetchingGetBankAccountReasons });
    };

    const storeBankAccountReason = (data: BankAccountReason, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.BANK_ACCOUNT_REASONS.STORE_BANK_ACCOUNT_REASON,
            body: data,
            setFetching: setFetchingStoreBankAccountReason
        });
    };

    const editBankAccountReason = (id: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: EndPoints.BANK_ACCOUNT_REASONS.EDIT_BANK_ACCOUNT_REASON.replace(':id', id.toString()),
            setFetching: setFetchingEditBankAccountReason
        });
    };

    const updateBankAccountReason = (id: number, data: BankAccountReason, events: ServiceEvents = {}) => {
        doPut({
            ...events,
            url: EndPoints.BANK_ACCOUNT_REASONS.UPDATE_BANK_ACCOUNT_REASON.replace(':id', id.toString()),
            body: data,
            setFetching: setFetchingUpdateBankAccountReason
        });
    };

    const deleteBankAccountReason = (id: number, events: ServiceEvents = {}) => {
        doDelete({
            ...events,
            url: EndPoints.BANK_ACCOUNT_REASONS.DELETE_BANK_ACCOUNT_REASON.replace(':id', id.toString()),
            setFetching: setFetchingDeleteBankAccountReason
        });
    };

    const activeBankAccountReason = (id: number, active: boolean, events: ServiceEvents = {}) => {
        doPost({
            ...events,
            url: EndPoints.BANK_ACCOUNT_REASONS.ACTIVE_BANK_ACCOUNT_REASON.replace(':id', id.toString()),
            body: { active },
            setFetching: setFetchingActiveBankAccountReason
        });
    };

    return {
        fetchingGetBankAccountReasons,
        fetchingStoreBankAccountReason,
        fetchingEditBankAccountReason,
        fetchingUpdateBankAccountReason,
        fetchingDeleteBankAccountReason,
        fetchingActiveBankAccountReason,
        getBankAccountReasons,
        storeBankAccountReason,
        editBankAccountReason,
        updateBankAccountReason,
        deleteBankAccountReason,
        activeBankAccountReason
    };
};

export default useBankAccountReasonService;
